import React, { useState } from 'react';
import Header from '../Layout/Header';
import './css/wallet-dashboard.css';
import Sidebar from "../Layout/Sidebar";
import { Layout } from "antd";
import CustomHeader from "../Layout/Header";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

// Images & Icons
import ArrowLeftLandingBanner from './img/Arrow-Left-LandingBanner.svg';
import ArrowRightLandingBanner from './img/Arrow-Right-LandingBanner.svg';
import PurchaseIcon from './img/Purchase-icon.svg';
import DistributionIcon from './img/Distribution-icon.svg';
import RedemptionIcon from './img/Redemption-icon.svg';
import TransactionRecordsIcon from './img/TransactionRecords-icon.svg';
import QuoteImage from './img/Quote.svg';
import CarouselImage1 from './img/carousel_Back-to-Office-Perks.jpg';
import CarouselImage2 from './img/carousel_Employee-Benefits-Plan.jpg';
import CarouselImage3 from './img/carousel_New-Employee-Onboarding.jpg';
import RewardRecognitionImg from './img/carousel_Rewards-&-Recognition.jpg';
import FestivalsEventsImg from './img/carousel_Festivals-&-Events.jpg';
import CustomPlansImg from './img/carousel_Custom-Plans.jpg';
import RightArrow from './img/right-arrow.svg';
import RightArrowWhite from './img/right-arrow-white.svg';
import ArrowWithCircle from './img/ArrowWithCircle-Yellow.svg';
import BlurredCoin from './img/blurred-coin.png';

// Custom Arrow Components
const PrevArrow = (props) => (
  <button {...props} className="slick-arrow slick-prev" aria-label="Previous">
    <img src={ArrowLeftLandingBanner} alt="Left Arrow" className='HeaderBannerArrow' />
  </button>
);

const NextArrow = (props) => (
  <button {...props} className="slick-arrow slick-next" aria-label="Next">
    <img src={ArrowRightLandingBanner} alt="Right Arrow" className='HeaderBannerArrow' />
  </button>
);


function WalletLanding() {
  const [collapsed, setCollapsed] = useState(true); 
  const toggleCollapsed = () => setCollapsed((prevState) => !prevState);

  // Slider settings
  const bannerSliderSettings = {
    autoplay: true,
    autoplaySpeed: 5000,
    pauseOnHover: true,
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: true,
    nextArrow: <NextArrow />,
    prevArrow: <PrevArrow />,
    dots: true,
  };

  const walletCarouselSettings = {
    autoplay: true,
    infinite: false,
    autoplaySpeed: 5000,
    pauseOnHover: true,
    infinite: true,
    slidesToShow: 3,
    slidesToScroll: 1,
    // arrows: true,
    dots: true,
    // nextArrow: <NextArrow />,
    // prevArrow: <PrevArrow />,
    responsive: [
      { breakpoint: 992, settings: { slidesToShow: 2 } },
      { breakpoint: 600, settings: { slidesToShow: 1 } }
    ]
  };

  const testimonialSliderSettings = {
    infinite: true,
    className: "center",
    centerMode: true,
    slidesToShow: 1,
    centerPadding: "120px",
    slidesToScroll: 1,
    arrows: true,
    dots: true,
    nextArrow: <NextArrow />,
    prevArrow: <PrevArrow />,
    responsive: [
      { breakpoint: 992, settings: { slidesToShow: 1 } }
    ]
  };

  return (
    <>
    <Layout>
      <Sidebar collapsed={collapsed} />
      <CustomHeader collapsed={collapsed} toggleCollapsed={toggleCollapsed} />
      <Layout className={collapsed ? 'PageLayout CollapsedPageLayout' : 'PageLayout'}>
        <div className="PageContent">
          <div className='WalletLandingHeader'>
            <div className='WalletHeader_Banner'>
              <Slider {...bannerSliderSettings}>
                <a href='/wallet-dashboard'>
                  <img src='https://smartworks-production.s3.ap-southeast-1.amazonaws.com/assets/Wallet-Landing-Banner.png' className='w-100' alt="banner1"/>
                </a>
                <a href='/wallet-dashboard'>
                  <img src='https://smartworks-production.s3.ap-southeast-1.amazonaws.com/assets/Wallet-Landing-Banner1.png' className='w-100' alt="banner2"/>
                </a>
              </Slider>
            </div>
          </div>

          <section className='Wallet_Howitworks pb-0'>
            <div className='Wallet_Titles'>
              <h2>
                <span>How it Works</span>
              </h2>
            </div>
            <div className='container'>
              <div className='row Howitworks_Container'>
                <div className='col-md-3'>
                  <div className='Howitworks_Box'>
                    <div className='Howitworks_Box_Image'>
                      <img src={PurchaseIcon} />
                    </div>
                    <div className='Howitworks_Box_Content'>
                      <h3>Purchase</h3>
                      <p>
                        <span>Add points to company wallet.</span>
                        <span>1 INR =  1 Wallet Point</span>
                      </p>
                    </div>
                    <img src={ArrowWithCircle} className='ArrowWithCircle' />
                  </div>
                </div>
                <div className='col-md-3'>
                  <div className='Howitworks_Box'>
                    <div className='Howitworks_Box_Image'>
                      <img src={DistributionIcon} />
                    </div>
                    <div className='Howitworks_Box_Content'>
                      <h3>Distribution</h3>
                      <p>
                        <span>Automate or strategically distribute points to employees</span>
                      </p>
                    </div>
                    <img src={ArrowWithCircle} className='ArrowWithCircle' />
                  </div>
                </div>
                <div className='col-md-3'>
                  <div className='Howitworks_Box'>
                    <div className='Howitworks_Box_Image'>
                      <img src={RedemptionIcon} />
                    </div>
                    <div className='Howitworks_Box_Content'>
                      <h3>Redemption</h3>
                      <p>
                        <span>Hassle-free redemption across Smartworks services. T & C apply</span>
                      </p>
                    </div>
                    <img src={ArrowWithCircle} className='ArrowWithCircle' />
                  </div>
                </div>
                <div className='col-md-3'>
                  <div className='Howitworks_Box Howitworks_Box_Last'>
                    <div className='Howitworks_Box_Image'>
                      <img src={TransactionRecordsIcon} />
                    </div>
                    <div className='Howitworks_Box_Content'>
                      <h3>Transaction Records</h3>
                      <p>
                        <span>Access redemption history to monitor usage and trends</span>
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className='text-center py-3'>
              <a className='btn btn-dark ExploreNow_btn' href='/wallet-dashboard'>
                <span>Explore now</span>
                <img src={RightArrowWhite} />
              </a>
            </div>

            <div className='container-fluid mt-5'>
              <div className='row'>
                <div className='col-md-5'>
                  <div className='d-flex justify-content-between'>
                    <div>&nbsp;</div>
                    <div className='Wallet_Titles mr-5 mt-4'>
                      <h2 className='text-left'>
                        Supercharge your Workforce<br /> with&nbsp;
                        <span>SW Wallet Points</span>
                      </h2>
                    </div>
                  </div>
                </div>
                <div className='col-md-7'>
                  <div className='WalletCarousel_Container'>
                    <Slider {...walletCarouselSettings}>
                      <div className='WalletCarousel'>
                        <div className='WalletCarousel_Image'>
                          <img src={CarouselImage1} />
                        </div>
                        <div className='WalletCarousel_Description'>
                          <h3>Back to Office Perks</h3>
                          <p>Encourage attendance with facial recognition-based entry points.</p>
                          <div className='WalletCarousel_Button'>
                            <a href='/wallet-dashboard'>
                              <span>Setup Wallet Points</span>
                              <img src={RightArrow} />
                            </a>
                          </div>
                        </div>
                      </div>
                      <div className='WalletCarousel'>
                        <div className='WalletCarousel_Image'>
                          <img src={CarouselImage2} />
                        </div>
                        <div className='WalletCarousel_Description'>
                          <h3>Employee Benefit Plan</h3>
                          <p>Improve talent management by allocating wallet points to your engagement budget.</p>
                          <div className='WalletCarousel_Button'>
                            <a href='/wallet-dashboard'>
                              <span>Setup Wallet Points</span>
                              <img src={RightArrow} />
                            </a>
                          </div>
                        </div>
                      </div>
                      <div className='WalletCarousel'>
                        <div className='WalletCarousel_Image'>
                          <img src={CarouselImage3} />
                        </div>
                        <div className='WalletCarousel_Description'>
                          <h3>New Employee Onboarding</h3>
                          <p>Welcome new hireswith wallet points in their onboarding kits.</p>
                          <div className='WalletCarousel_Button'>
                            <a href='/wallet-dashboard'>
                              <span>Setup Wallet Points</span>
                              <img src={RightArrow} />
                            </a>
                          </div>
                        </div>
                      </div>
                      <div className='WalletCarousel'>
                        <div className='WalletCarousel_Image'>
                          <img src={RewardRecognitionImg} />
                        </div>
                        <div className='WalletCarousel_Description'>
                          <h3>Rewards & Recognition</h3>
                          <p>Link wallet points to performance bonuses for acknowledging achievements.</p>
                          <div className='WalletCarousel_Button'>
                            <a href='/wallet-dashboard'>
                              <span>Setup Wallet Points</span>
                              <img src={RightArrow} />
                            </a>
                          </div>
                        </div>
                      </div>
                      <div className='WalletCarousel'>
                        <div className='WalletCarousel_Image'>
                          <img src={FestivalsEventsImg} />
                        </div>
                        <div className='WalletCarousel_Description'>
                          <h3>Festivals & Events</h3>
                          <p>Celebrate milestones with wallet points, best utilizing your employee engagement budget</p>
                          <div className='WalletCarousel_Button'>
                            <a href='/wallet-dashboard'>
                              <span>Setup Wallet Points</span>
                              <img src={RightArrow} />
                            </a>
                          </div>
                        </div>
                      </div>
                      <div className='WalletCarousel'>
                        <div className='WalletCarousel_Image'>
                          <img src={CustomPlansImg} />
                        </div>
                        <div className='WalletCarousel_Description'>
                          <h3>Custom Plans</h3>
                          <p>Distribute points for on-the-spot recognition, client appreciation, & more</p>
                          <div className='WalletCarousel_Button'>
                            <a href='/wallet-dashboard'>
                              <span>Setup Wallet Points</span>
                              <img src={RightArrow} />
                            </a>
                          </div>
                        </div>
                      </div>
                    </Slider>
                  </div>
                </div>
              </div>
            </div>
          </section>

          <section className='TestimonialSection d-none'>
            <img src={BlurredCoin} className='BlurredCoin' />
            <div className='container'>
              <div className='row justify-content-md-center'>
                <div className='col-md-8'>
                  <div className='Wallet_Titles'>
                    <h2>
                      <span>Testimonials</span>
                    </h2>
                  </div>
                  <div className='TestimonialSliderContainer'>
                    <Slider {...testimonialSliderSettings}>
                      <div className='TestimonialSlides'>
                        <div className='TestimonialSlider_Box'>
                            <div><img src={QuoteImage} className='QuoteIcon' /></div>
                            <div className='TestimonialSlider_Content'>
                            Lorem ipsum dolor sit amet, consectetur adipiscing elit. Morbi congue quam ut nibh auctor,
                            </div>
                            <div className='TestimonialSlider_Stars'>
                            <i class="fa fa-star" aria-hidden="true"></i>
                            <i class="fa fa-star" aria-hidden="true"></i>
                            <i class="fa fa-star" aria-hidden="true"></i>
                            <i class="fa fa-star-half-o" aria-hidden="true"></i>
                            <i class="fa fa-star-o" aria-hidden="true"></i>
                            </div>
                            <div className='TestimonialSlider_Name'>
                            <h4>Name 1</h4>
                            <span>Designation Goes Here</span>
                            </div>
                        </div>
                      </div>
                      
                      <div className='TestimonialSlides'>
                        <div className='TestimonialSlider_Box'>
                            <div><img src={QuoteImage} className='QuoteIcon' /></div>
                            <div className='TestimonialSlider_Content'>
                            Lorem ipsum dolor sit amet, consectetur adipiscing elit. Morbi congue quam ut nibh auctor,
                            </div>
                            <div className='TestimonialSlider_Stars'>
                            <i class="fa fa-star" aria-hidden="true"></i>
                            <i class="fa fa-star" aria-hidden="true"></i>
                            <i class="fa fa-star" aria-hidden="true"></i>
                            <i class="fa fa-star-half-o" aria-hidden="true"></i>
                            <i class="fa fa-star-o" aria-hidden="true"></i>
                            </div>
                            <div className='TestimonialSlider_Name'>
                            <h4>Name 2</h4>
                            <span>Designation Goes Here</span>
                            </div>
                        </div>
                      </div>
                      
                      <div className='TestimonialSlides'>
                        <div className='TestimonialSlider_Box'>
                            <div><img src={QuoteImage} className='QuoteIcon' /></div>
                            <div className='TestimonialSlider_Content'>
                            Lorem ipsum dolor sit amet, consectetur adipiscing elit. Morbi congue quam ut nibh auctor,
                            </div>
                            <div className='TestimonialSlider_Stars'>
                            <i class="fa fa-star" aria-hidden="true"></i>
                            <i class="fa fa-star" aria-hidden="true"></i>
                            <i class="fa fa-star" aria-hidden="true"></i>
                            <i class="fa fa-star-half-o" aria-hidden="true"></i>
                            <i class="fa fa-star-o" aria-hidden="true"></i>
                            </div>
                            <div className='TestimonialSlider_Name'>
                            <h4>Name 3</h4>
                            <span>Designation Goes Here</span>
                            </div>
                        </div>
                      </div>
                    </Slider>
                  </div>
                </div>
              </div>
            </div>
          </section>

          <div className='WalletLandingFooter' style={{ paddingTop: '40px' }}>
            <img src="https://clientportal.sworks.co.in/assets/images/SW_logo_black.svg" />
          </div>
        </div>
      </Layout>
    </Layout>
    </>
  );
}
export default WalletLanding;
